import React, { useEffect, useContext } from "react";

import { callApi } from "bodycodi/cmap/app/js/common";
import Schedule from "bodycodi/cmap/app/components/cmap2010/schedule";
import MemberMngt from "bodycodi/cmap/app/components/cmap3010/memberMngt";
import { StateContext } from "bodycodi/cmap/app/components/cmap2010/home";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import CommunityPage from "../cmap4010/index";
import PassInfoPop from "bodycodi/cmap/app/components/common/passInfoPop";
import TermsConfirmPop from "bodycodi/cmap/app/components/cmap2010/TermsConfirmPop";
import Store from "bodycodi/cmap/app/components/store";
import BodycodiPlusMngtTab from "bodycodi/cmap/app/components/cmap5010/bodycodiPlus/index";

const Body = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  useEffect(() => {
    callApi("/service/terms", {}, "GET").then((res) => {
      if (res.termAgree !== "Y") {
        dispatch({
          type: "POP_UP_OPEN",
          id: "CONFIRM_TERMS_POP",
          open: { confirmTermsPop: true },
        });
      }
    });
  }, []);

  return (
    <div className="body">
      {state.bodyState === 0 && <Schedule />}
      {state.bodyState === 1 && <MemberMngt />}
      {state.bodyState === 2 && <CommunityPage />}
      {state.bodyState === 3 && <Store />}
      {state.bodyState === 4 && <BodycodiPlusMngtTab />}
      <PassInfoPop />
      <TermsConfirmPop />
    </div>
  );
};

export default Body;
